import React, { useRef, useState } from 'react';

// UPDATED: Added userRole to props
export default function ProgramsList({ fetchPools, setSelectedProgram, selectedPool, setActiveTab, userRole }) {
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);

  const allPrograms = [
    { id: 'Group Training', icon: 'fa-users' },
    { id: 'Personal Training', icon: 'fa-user-clock' },
    { id: 'Premium Membership', icon: 'fa-id-card' },
    { id: 'Pay and Use Pool', icon: 'fa-person-swimming' }
  ];

  const availablePrograms = selectedPool 
    ? allPrograms.filter(p => selectedPool.programs?.includes(p.id))
    : [];

  // Trigger hidden input on image click (only if admin)
  const handleImageClick = () => {
    if (userRole === 'admin') {
      fileInputRef.current.click();
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !selectedPool) return;

    // Extract original extension to append to the new name
    const newFileName = `pool_${selectedPool.id || selectedPool._id}`;

    const formData = new FormData();
    formData.append('image', file);
    formData.append('fileName', newFileName);

    const token = localStorage.getItem('token'); 

    setIsUploading(true);
    try {
      const res = await fetch(`https://tsaapis.operate.live/api/upload`, {
        method: 'POST',
        headers: {
          'x-auth-token': token || ''
        },
        credentials: 'include',
        body: formData
      });

      if (res.ok) {
        console.log('Image uploaded successfully!');
        await fetchPools();
      } else {
        console.error('Failed to upload image');
      }
    } catch (error) {
      console.error('Error during upload:', error);
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = ''; 
    }
  };

  return (
    <div className="admin-card programs-main" style={{ padding: '2rem' }}>
      
      {selectedPool && (
        <div className="pool-details-banner">
          
          {/* Hidden file input for uploading */}
          <input 
            type="file" 
            ref={fileInputRef} 
            onChange={handleImageUpload} 
            accept="image/*" 
            style={{ display: 'none' }} 
          />

          {/* Wrapper to handle loading state visuals */}
          <div style={{ position: 'relative', display: 'flex' }}>
            <img 
              src={selectedPool.picUrl || selectedPool.pic} 
              alt={selectedPool.Name || selectedPool.name} 
              onClick={handleImageClick}
              style={{ 
                filter: (selectedPool.active !== false && selectedPool.isActive !== false) ? 'none' : 'grayscale(100%)',
                cursor: userRole === 'admin' ? 'pointer' : 'default',
                opacity: isUploading ? 0.5 : 1,
                transition: 'opacity 0.2s'
              }} 
            />
            {isUploading && (
              <span style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: 'white',
                fontWeight: 'bold',
                textShadow: '1px 1px 2px black'
              }}>
                Uploading...
              </span>
            )}
          </div>

          <div className="pool-info">
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <h3>
                  {selectedPool.Name || selectedPool.name} 
                  {(selectedPool.active === false || selectedPool.isActive === false) && (
                    <span className="badge" style={{ backgroundColor: 'rgba(239, 68, 68, 0.2)', color: '#ef4444', border: '1px solid #ef4444', marginLeft: '10px', verticalAlign: 'middle' }}>
                      Inactive
                    </span>
                  )} {/* Hide Edit button for students */}
                {userRole === 'admin' && (
                  <button className="btn-small btn-action" onClick={() => setActiveTab('edit-pool')} style={{ margin: 0 }}>
                    <i className="fas fa-edit"></i>
                  </button>
                )}
                </h3>
                <h4>{selectedPool.Title || selectedPool.title}</h4>
              </div>
              
              {/* RIGHT ALIGNED METRICS & ACTIONS */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px' }}>
                
                {/* MOVED: Capacity Badge */}
                <div style={{ color: 'var(--text-gray)', fontSize: '0.8rem', backgroundColor: 'rgba(255,255,255,0.05)', padding: '5px 12px', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.1)' }}>
                  <i className="fas fa-users" style={{ color: '#10b981', marginRight: '6px' }}></i>
                  Capacity: <strong style={{ color: 'white' }}>{selectedPool.Capacity || selectedPool.capacity || 50}</strong>
                </div>

               
              </div>

            </div>
            
            <p style={{ color: 'var(--text-gray)', fontSize: '0.9rem', margin: '10px 0 5px 0' }}>
              <i className="fas fa-map-marker-alt" style={{ color: '#ef4444', marginRight: '8px' }}></i>
              {selectedPool.Address || selectedPool.address}
            </p>
            
            <a href={selectedPool.mapsURL || selectedPool.mapUrl} target="_blank" rel="noreferrer" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem', textDecoration: 'none', display: 'inline-block', marginBottom: '10px' }}>
              <i className="fas fa-external-link-alt"></i> Open in Maps
            </a>
            
            <div className="facilities-list">
              {(selectedPool.Facilities || selectedPool.facilities || []).map((fac, idx) => (
                <span key={idx} className="badge" style={{ fontSize: '0.75rem', background: 'rgba(255,255,255,0.05)', color: 'white', border: '1px solid rgba(255,255,255,0.2)' }}>
                  {fac}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      <h2 style={{ fontSize: '1.4rem', border: 'none', padding: 0 }}>Programs at {selectedPool?.Name || selectedPool?.name}</h2>
      
      {(selectedPool?.active === false || selectedPool?.isActive === false) ? (
        <p style={{ color: '#ef4444', marginTop: '1rem', fontWeight: 'bold' }}><i className="fas fa-exclamation-triangle"></i> This pool is currently inactive.</p>
      ) : availablePrograms.length === 0 ? (
        <p style={{ color: 'var(--text-gray)', marginTop: '1rem' }}>No programs have been assigned to this pool yet.</p>
      ) : (
        <div className="programs-grid-container">
          <div className="programs-grid">
            {availablePrograms.map(p => (
              <div key={p.id} className="program-dash-card" onClick={() => setSelectedProgram(p.id)}>
                <i className={`fas ${p.icon}`}></i>
                <h3>{p.id}</h3>
              </div>
            ))}
          </div>
        </div>
      )}
      
    </div>
  );
}